import Script from "next/script";
import { useEffect, useState } from "react";
import { useWebTranslation } from "translations";
import { getSocialLadderSettings } from "utils/site";

export const SocialLadderRegistration = () => {
  const [isMounted, setIsMounted] = useState(false);
  const { i18n } = useWebTranslation();

  const { appGuid, areaGuid, shopName } = getSocialLadderSettings() || {};

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted || !appGuid || !areaGuid) {
    return null;
  }

  return (
    <>
      <div
        id="slWebAppWidget"
        style={{ display: "flex", justifyContent: "center" }}
      />
      <Script
        src="https://socialladder.rkiapps.com/SLWeb/slweb-frame.js"
        strategy="afterInteractive"
        onLoad={() => {
          const campGuid =
            (window as any).getParameterFromURLByName?.("campGuid") || "";
          const resGuid =
            (window as any).getParameterFromURLByName?.("resGuid") || "";
          (window as any).loadSLApplicationWidget?.(
            areaGuid,
            appGuid,
            "",
            "",
            campGuid,
            shopName,
            resGuid,
            i18n?.language
          );
        }}
      />
    </>
  );
};
